//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'login',
  data () {
    return {
      title: '',
      name: '',
      phone: '',
    }
  },
  created(){
    if(!this.$func.getLocal('token')){
      this.getCode();
    }
  },
  methods:{
     getCode(){
      var local = window.location.href
      this.code = this.getUrlCode().code 
      var appid = 'wx293713f8b5be3b5b' 
      if (this.code == null || this.code === '') {
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
      } else {
        this.login();
      }
    },
    getUrlCode() {
      var url = window.location.href
      var theRequest = new Object()
      if (url.indexOf("?") != -1) {
         var urls = url.split("?")
          var strs = urls[1].split("&")
          for(var i = 0; i < strs.length; i++) {
              theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
          }
      }
      return theRequest
    },
    login(){
        this.$api.login({code:this.code}).then((res)=>{
          if(res){
            if(res.data.token){
              this.$func.setLocal('token',res.data.token);
            }
          }
        })  
    },
    submit(){
        let that = this;
        if (!that.title) {
            that.$func.showToast('请输入渠道名称');
            return false;
        }
        if (!that.name) {
            that.$func.showToast('请输入联系人');
            return false;
        }
        if (!that.phone) {
            that.$func.showToast('请输入手机号');
            return false;
        }
        that.$api.bindBalanceMsg({
            title: that.title,
            name: that.name,
            phone: that.phone,
        }).then((res)=>{
          if(res){
            that.$func.showToast('已成功绑定余额变动通知提醒');
          }
        });
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/bindBalanceMsg.vue